import script from "./province-panel.vue?vue&type=script&lang=ts&setup=true"
export * from "./province-panel.vue?vue&type=script&lang=ts&setup=true"

import "./province-panel.vue?vue&type=style&index=0&id=0722f06f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0722f06f"]])

export default __exports__